import { Routes, Route, Navigate, useLocation } from "react-router-dom"

import styles from './App.module.css'

import SignIn from '@pages/Auth/SignIn';
import LogIn from "@pages/Auth/LogIn";
import Forget from "@pages/Auth/Forget";

import cn from 'classnames';

import TopBar from "@components/TopBar";
import ChangePassword from "./pages/Auth/ChangePassword";
import Places from "@pages/Places";
import Place from "@pages/PlaceWrapper";
import ApproveExpired from "@pages/Auth/ApproveExpired";
import Approve from "@pages/Auth/ApprovePage";
import useAuth from "./hooks/useAuth/useAuth";
import Organization from "@pages/Organization";
import Organizations from "@pages/Organizations";
import Error from "@pages/Error";
import { useEffect } from "react";
import { Loader } from "@mantine/core";
import ApprovePassword from "./pages/Auth/ApprovePassword";
import Profile from "./pages/Profile";
import {useTranslation} from "react-i18next";

const ProtectedRoute = ({ children }) => {
  const [{ currentUser, isAuthorized }] = useAuth();
  let location = useLocation();

  if (!currentUser && isAuthorized) {
    return <Navigate to="/log_in" state={{ from: location }} replace />
  }
  return children
};

const ProtectedRouteAuthorized = ({ children }) => {
  const [{ currentUser, isAuthorized }] = useAuth();
  let location = useLocation();

  if (currentUser && isAuthorized) {
    return <Navigate to={currentUser.admin ? "/organizations" : "/places"} state={{ from: location }} replace />
  }
  return children
};

function App() {
  const [{ isAuthorized, currentUser }] = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('application.name')
    window.recaptchaOptions = {
      useRecaptchaNet: true,
      enterprise: true,
      lang : 'en'
    };

    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'G-WXX0P3RZ0K');
    window.gtag = gtag;
  }, [])

  if (!isAuthorized) {
    return (
      <div className={styles.loader}>
        <Loader />
      </div>
    )
  }

  return (
    <div className={cn("App", currentUser && "AppAuth")}>
      <div className={styles.main}>
        <TopBar />

        <div className={styles.content}>
          <Routes>
            <Route path="/sign_in" element={<ProtectedRouteAuthorized><SignIn /></ProtectedRouteAuthorized>}></Route>
            <Route path="/account_recovery/:id" element={<ChangePassword />}></Route>
            <Route path="/log_in" element={<ProtectedRouteAuthorized><LogIn /></ProtectedRouteAuthorized>}></Route>
            <Route path="/password_changed" element={<ProtectedRouteAuthorized><ApprovePassword /></ProtectedRouteAuthorized>}></Route>
            <Route path="/forget" element={<Forget />}></Route>
            <Route path="/places/:id" element={<ProtectedRoute><Place /></ProtectedRoute>} />
            <Route path="/place/:id" element={<ProtectedRoute><Place /></ProtectedRoute>} />
            <Route path="/places" element={<ProtectedRoute><Places /></ProtectedRoute>}></Route>
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>}></Route>
            <Route path="/organizations" element={ currentUser?.admin ? <ProtectedRoute><Organizations /></ProtectedRoute> : <ProtectedRoute><Error /></ProtectedRoute>}></Route>
            <Route path="/organizations/:id" element={currentUser?.admin ?  <ProtectedRoute><Organization /></ProtectedRoute> : <ProtectedRoute><Error /></ProtectedRoute>} />
            <Route path="/approve/:id" element={<Approve />}></Route>
            <Route path="/approve/expired" element={<ApproveExpired />}></Route>
            <Route path="/" element={<ProtectedRouteAuthorized><LogIn /></ProtectedRouteAuthorized>}></Route>
            <Route path="*" element={<Error />}></Route>
            
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default App;
